export const localStorageFields = {
  currentUser: 'currentUser',
  language: 'language',
  deviceSettings: 'deviceSettings',
  groupCallsPopupPosition: 'groupCallsPopupPosition',
  groupCallsMinimizePopupPosition: 'groupCallsMinimizePopupPosition'
} as const
